// frontend/src/config/api.js
const isProduction = process.env.NODE_ENV === 'production';

// En producción usamos la variable de entorno, o la URL hardcodeada de Render como fallback.
// En desarrollo local dejamos vacío para que el proxy `setupProxy.js` se encargue.
export const API_URL = isProduction
  ? (process.env.REACT_APP_API_URL || 'https://qproject-backend.onrender.com')
  : '';
